export default {
  "pdfAccountsReceivableBalance.monthDate": "年月",
  "pdfAccountsReceivableBalance.cinemaName": "対象劇場",
  "pdfAccountsReceivableBalance.exportAt": "作成",

  "pdfAccountsReceivableBalance.th.clientCode": "コード",
  "pdfAccountsReceivableBalance.th.clientName": "取引先名",

  "pdfAccountsReceivableBalance.th.preMonthEndBalance": "前月末残高",
  "pdfAccountsReceivableBalance.th.currentMonthOccurs": "当月発生",
  "pdfAccountsReceivableBalance.th.currentMonthPay": "当月回収",

  "pdfAccountsReceivableBalance.th.account": "本社入金",
  "pdfAccountsReceivableBalance.th.offset": "相殺",
  "pdfAccountsReceivableBalance.th.cash": "現金回収",
  "pdfAccountsReceivableBalance.th.total": "合計",
  "pdfAccountsReceivableBalance.th.currentMonthEndBalance": "当月末残高",

  "pdfAccountsReceivableBalance.title": "売掛金残高一覧表",
  "pdfAccountsReceivableBalance.month": "対象月",
  "pdfAccountsReceivableBalance.placeholder": "選択してください",
  "pdfAccountsReceivableBalance.dailyPayDate": "請求日付",
  "pdfAccountsReceivableBalance.clientCode": "コード",
  "pdfAccountsReceivableBalance.invoiceRequestCode": "請求No",
  "pdfAccountsReceivableBalance.invoiceName": "表題",
};